import { useEffect, useMemo, useState } from "react";
import { Option } from "../../../types/types";
import useApi from "../useApi";
import webservice_url, {
  master_baseUrl,
} from "../../webservice/Webservice_url";

type dataTypes = {
  location_name: string;
  location_id: string;
};

export function useLocationByProjectId(
  projectId: string,
  selectedLocationId: string,
) {
  const [dataList, setDataList] = useState<dataTypes[]>([]);

  // API
  const { callApi, loading, error } = useApi<any>("", {
    method: "GET",
    autoCall: false,
    handleGlobalError: false,
  });

  const options = useMemo<Option[] | []>(() => {
    if (!dataList?.length) return [];

    return dataList?.map((d) => ({
      label: d?.location_name,
      value: d?.location_id ?? "",
    }));
  }, [dataList]);

  const fetchData = async () => {
    try {
      const res = await callApi(
        undefined,
        `${master_baseUrl}/projects/${projectId}/locations`,
      );
      setDataList(Array.isArray(res) ? res : (res?.data ?? []));
    } catch (err: any) {
      setDataList([]);
      console.error(err);
    }
  };

  useEffect(() => {
    if (!projectId) {
      setDataList([]);
      return;
    }
    fetchData();
  }, [projectId]);

  const selectedItem = useMemo<any>(() => {
    if (!selectedLocationId) return null;
    return dataList.find((d) => d?.location_id === selectedLocationId) ?? null;
  }, [dataList, selectedLocationId]);

  return { dataList, options, loading, selectedItem };
}

export function useLocationByMultiProjectId(
  projectId: string[],
  selectedLocationId?: string,
) {
  const [dataList, setDataList] = useState<dataTypes[]>([]);
  const { callApi, loading, error } = useApi<any>(
    webservice_url.getLocationByMultiProject,
    {
      method: "POST",
      autoCall: false,
      handleGlobalError: false,
    },
  );

  const options = useMemo<Option[] | []>(() => {
    if (!dataList?.length) return [];

    return dataList?.map((d) => ({
      label: d?.location_name,
      value: d?.location_name ?? "",
    }));
  }, [dataList]);

  //   fetch data
  const fetchData = async () => {
    try {
      const res = await callApi({
        projectIds: projectId,
      });
      setDataList(Array.isArray(res) ? res : (res?.data ?? []));
    } catch (err: any) {
      setDataList([]);
      console.error(err);
    }
  };

  useEffect(() => {
    if (!projectId.length) {
      setDataList([]);
      return;
    }
    fetchData();
  }, [projectId]);

  const selectedItem = useMemo<any>(() => {
    if (!selectedLocationId?.length) return null;
    return dataList.find((d) => d?.location_id === selectedLocationId) ?? null;
  }, [dataList, selectedLocationId]);
  return { dataList, options, loading, selectedItem };
}
